import { getStyle } from './getStyle';
import * as React from 'react';
import { WpdfText } from '../../pdf/WpdfText.';
import { WpdfView } from '../../pdf/WpdfView';

export function getAnhang(
    isPdf: boolean, anhang: JSX.Element[], getPageNum?: (key: string, page: number, level: number) => void
): JSX.Element[] {
    return (anhang || []).map((item: JSX.Element, idx: number) =>
        <WpdfView key={`anhang_${idx}`} style={getStyle('div')} pdf={isPdf}>
            <WpdfText
                pdf={isPdf}
                style={{ ...getStyle('h1', isPdf), marginBottom: '12pt', ...(!idx && isPdf && { marginTop: 0 }) }}
                getPageNum={(pageNumber: number) => typeof getPageNum === 'function' && getPageNum(`Anhang ${idx + 1}`, pageNumber, 1)}
            >
                {`Anhang ${idx + 1}`}
            </WpdfText>
            {item}
        </WpdfView>
    );
}
